import { Stepper, StepperStatus } from '@pay-com/components'
import { Logo } from '@pay-com/icons'
import { CloudSaveIndicator } from 'components/CloudSaveIndicator'
import type { CloudState } from 'components/CloudSaveIndicator/CloudSaveIndicator'
import { OnboardingStep } from '../OnboardingRegion/UsRegion/us-region-config'
import { StepValidationStatus } from '../types'

type OnboardingSidebarProps = {
  steps: OnboardingStep[]
  currentStepIndex: number
  stepStatuses: Record<string, StepValidationStatus>
  onStepClick: (index: number) => void
  cloudState: CloudState
}

const validationToStepperStatus: Record<StepValidationStatus, StepperStatus> = {
  untouched: 'default',
  error: 'error',
  valid: 'valid'
}

export const OnboardingSidebar = ({
  steps,
  currentStepIndex,
  stepStatuses,
  onStepClick,
  cloudState
}: OnboardingSidebarProps) => {
  const handleStepperClick = (stepperId: number) => {
    onStepClick(stepperId - 1)
  }

  const desktopSteps = steps.map((step, index) => ({
    id: index + 1,
    title: step.title,
    subTitle: step.shortDescription ?? step.description,
    status: validationToStepperStatus[stepStatuses[step.id] ?? 'untouched'],
    stepIcon: step.stepIcon
  }))

  const mobileSteps = steps.map((step, index) => ({
    id: index + 1,
    status: validationToStepperStatus[stepStatuses[step.id] ?? 'untouched']
  }))

  return (
    <>
      <div className="sticky top-0 z-10 flex w-full flex-col items-center border-b border-gray-200 bg-white p-4 md:hidden">
        <Logo className="mb-2 h-8" />
        <div className="flex w-full items-center justify-between gap-2">
          <Stepper
            activeStep={currentStepIndex + 1}
            setActiveStep={handleStepperClick}
            steps={mobileSteps}
            bulletClassNames={{ valid: '!bg-green-200' }}
            className="flex-1 select-none"
            bulletsStyle="circle"
          />
          <CloudSaveIndicator cloudState={cloudState} />
        </div>
      </div>
      <div className="sticky top-0 hidden h-screen w-[26rem] shrink-0 flex-col gap-10 overflow-y-auto border-r border-gray-200 p-8 md:flex">
        <Logo className="-ml-1 h-12" />
        <Stepper
          vertical
          activeStep={currentStepIndex + 1}
          setActiveStep={handleStepperClick}
          steps={desktopSteps}
          bulletClassNames={{ valid: '!bg-green-200' }}
          className="select-none"
          bulletsStyle="square"
          style={{
            titleClassName: '!text-lg !font-semibold !font-sans -mt-2 ml-2',
            subTitleClassName: '!text-sm !font-sans ml-2',
            stepDividerClassName: '!mt-3'
          }}
        />
      </div>
    </>
  )
}
